import React from "react";
import Image from "next/image";
import {Container} from "@/shared/components/shared";

export const Separator: React.FC = () => {
    return (
        <section className={'w-full bg-white'}>
            <Container className={'py-8 lg:py-12'}>
                <div className={'flex flex-col md:flex-row gap-6 md:gap-8'}>
                {/* Картинка слева */}
                <div className={'relative h-[300px] sm:h-[400px] md:h-[350px] xl:h-[400px] -mx-[22px] md:mx-0 md:w-1/2 overflow-hidden'}>
                    <Image
                        src={'/images/separator.jpg'}
                        alt={'Разделитель'}
                        fill
                        className={'object-cover md:object-contain object-right'}
                        priority={false}
                    />
                    {/* Градиент для плавного перехода в текст (только на больших экранах) */}
                    <div className={'hidden md:block absolute right-0 top-0 bottom-0 w-1/5 bg-gradient-to-l from-white to-transparent'} />
                </div>
                    
                    {/* Текст справа */}
                    <div className={'w-full md:w-1/2 flex items-center justify-center py-6 md:py-0'}>
                        <div>
                            <blockquote>
                                <p className={
                                    'text-black text-[24px] md:text-[32px] lg:text-[38px] xl:text-[45px] ' +
                                    'font-normal leading-[1.3] lg:leading-[1.4] italic'
                                }>
                                    "Доверьте нам искусство заботы об автомобиле, 
                                    пока Вы занимаетесь искусством жизни"
                                </p>
                                <footer className={'text-black text-[18px] md:text-[22px] lg:text-[26px] mt-6 lg:mt-8 not-italic'}>
                                    © Мастер-лидер <span className={'font-medium'}>Иван Шкригунов</span>
                                </footer>
                            </blockquote>
                        </div>
                    </div>
                </div>
            </Container>
        </section>
    );
};

